/**
 * Model definition for Sparkasse Assignment Box
 */
export interface FormsSparkasseAssignmentBox {
  __component: 'forms.sparkasse-assignment-box';
  id: string;
  assignmentHeadline?: string;
  assignmentSubline?: string;
  showReassignButton?: boolean;
  reassignOverline?: string;
  reassignText?: string;
}

export function isFormsSparkasseAssignmentBox(obj: { __component?: string }): obj is FormsSparkasseAssignmentBox {
  return obj.__component === 'forms.sparkasse-assignment-box';
}
